import { apolloClient } from './../apolloClient'

export const queryResolver = ({
  query,
  mutation,
  variables,
  fetchPolicy = 'network-only'
}) => {
  if (query) {
    return apolloClient?.query({
      query,
      variables,
      fetchPolicy
    })
  }
  return apolloClient?.mutate({
    mutation,
    variables
  })
}